import React, { Component, createContext, useEffect, useState } from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import TopNavigation from "./components/topNavigation";
import SideNavigation from "./components/sideNavigation";

import "./index.css";
import TonovaniPage from "./pages/TonovaniPage";
import HomePage from "./pages/HomePage";
import BaleniPage from "./pages/PackagesPage";
import HardenersPage from "./pages/HardenersPage";
import BazePage from "./pages/BazePage";
import CenikPage from "./pages/CenikPage";
import ExportRecepturPage from "./pages/ExportRecepturPage";
import ImportCenPage from "./pages/ImportCenPage";
import ImportRecepturPage from "./pages/ImportRecepturPage";
import KopirovaniRecepturPage from "./pages/KopirovaniRecepturPage";
import LoginPage from "./pages/LoginPage";
import NastaveniPage from "./pages/NastaveniPage";
import OdstinyPage from "./pages/OdstinyPage";
import PigmentyPage from "./pages/PigmentyPage";
import PodporaPage from "./pages/PodporaPage";
import ProdejciPage from "./pages/ProdejciPage";
import RecepturyPage from "./pages/RecepturyPage";
import SlevyPage from "./pages/SlevyPage";
import UzivatelePage from "./pages/UzivatelePage";
import VyrobkyPage from "./pages/ProductsPage";
import VzorkovnicePage from "./pages/VzorkovnicePage";
import AccessDeniedPage from "./pages/AccessDeniedPage"
import { useTranslation } from "react-i18next";
import MainLayout from "./layouts/MainLayout";
import EmptyLayout from "./layouts/EmptyLayout";
import { MainLayoutRoute } from "./layouts/MainLayoutRoute";
import { EmptyLayoutRoute } from "./layouts/EmptyLayoutRoute";
import { apiGetCurrentUser } from "./services/UsersService";
import { useDispatch, useSelector } from "react-redux";
import { userLoginAction } from "./redux/actions";
import { useHistory } from "react-router-dom";
import Notification from "./components/common/Notification";
import NotImplementedPage from "./pages/NotImplementedPage";
import { checkAdditionalRole, checkCrud } from "./helpers/userRolesHelper";
import KopirovaniRecepturReportPage from "./pages/KopirovaniRecepturReportPage";
import MainPageIfToningIsDenied from "./pages/MainPageIfToningIsDenied";
import MainPageIfToningIsBeingLoaded from "./pages/MainPageIfToningIsBeingLoaded";
import MainPageLoadingNeededConfiguration from "./pages/MainPageLoadingNeededConfiguration";
import RecepturyVlastniPage from "./pages/RecepturyVlastniPage";

require("./App.css");

const App = () => {
  const { t } = useTranslation();
  const contextLevel = "Retail";
  const dispatch = useDispatch();
  const history = useHistory();
  const [toningPermissionsLoaded, setToningPermissionsLoaded] = useState(false);
  const [canBasis, setCanBasis] = useState(false);
  const [canToning, setCanToning] = useState(false);
  const [canReceipt, setCanReceipt] = useState(false);
  const [canReceiptAdmin, setCanReceiptAdmin] = useState(false);
  const [canCopyReceipts, setCanCopyReceipts] = useState(false);
  const [canCustomReceipts, setCanCustomReceipts] = useState(false);
  const [canProduct, setCanProduct] = useState(false);
  const [canPackage, setCanPackage] = useState(false);
  const [canHardener, setCanHardener] = useState(false);
  const [canPigment, setCanPigment] = useState(false);
  const [canSampleCard, setCanSampleCard] = useState(false);
  const [canColor, setCanColor] = useState(false);
  const [canSeller, setCanSeller] = useState(false);
  const [canUser, setCanUser] = useState(false);
  const [canDiscount, setCanDiscount] = useState(false);
  const [canImportPrices, setCanImportPrices] = useState(false);

  const userInfo = useSelector((state: any) => state.userInfo);

  const [loadingDataForRoutes, setLoadingDataForRoutes] = useState(true);

  useEffect(() => {
    if (userInfo) {
      setCanBasis(checkCrud('base', 'read', userInfo));
      setCanToning(checkCrud('toning', 'read', userInfo));
      setCanReceipt(checkCrud('receipt', 'read', userInfo));
      setCanCopyReceipts(checkAdditionalRole('copyReceipt', userInfo));
      setCanReceiptAdmin(checkCrud('receipt', 'admin', userInfo));
      setCanCustomReceipts(checkAdditionalRole('customReceipts', userInfo));
      setCanProduct(checkCrud('product', 'read', userInfo));
      setCanPackage(checkCrud('package', 'read', userInfo));
      setCanHardener(checkCrud('hardener', 'read', userInfo));
      setCanPigment(checkCrud('pigment', 'read', userInfo));
      setCanSampleCard(checkCrud('sampleCard', 'read', userInfo));
      setCanColor(checkCrud('color', 'read', userInfo));
      setCanSeller(checkCrud('seller', 'read', userInfo));
      setCanUser(checkCrud('user', 'read', userInfo));
      setCanDiscount(checkCrud('discount', 'read', userInfo));
      setCanImportPrices(checkAdditionalRole('priceList', userInfo));

      if (checkCrud('toning', 'read', userInfo)) {

        setToningPermissionsLoaded(true);
      }
      else {
        setToningPermissionsLoaded(true);
      }
    }
  }, [userInfo])

  useEffect(() => {
    document.title = 'Teluria IS';

    apiGetCurrentUser()
      .then((responseData) => {
        dispatch(userLoginAction(JSON.stringify(responseData.data)));

        if (responseData.data.Anonymous) {
          history.push("/login");
        }
      })
      .catch(() => {
        if (window.location.href.indexOf("login") <= 0) {
          window.location.href = "/login";
        }
      });
  }, []);

  return (
    <div>
      <Notification />
      <Router>
        <Switch>
          <EmptyLayoutRoute
            contextLevel={contextLevel}
            path="/login"
            component={LoginPage}
          />

          {<EmptyLayoutRoute
            contextLevel={contextLevel}
            exact
            path="/"
            component={MainPageLoadingNeededConfiguration}
          />}

          {<MainLayoutRoute
            contextLevel={contextLevel}
            exact
            path="/tonovani"
            component={TonovaniPage}
          />}

          <MainLayoutRoute
            contextLevel={contextLevel}
            exact
            path="/noaccess"
            component={AccessDeniedPage}
          />

          <MainLayoutRoute
            contextLevel={contextLevel}
            path="/__*"
            component={NotImplementedPage}
          />

          {canPackage && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/baleni"
            component={BaleniPage}
          />}
          {canHardener && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/tuzidla"
            component={HardenersPage}
          />}
          {canBasis && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/baze"
            component={BazePage}
          />}
          <MainLayoutRoute
            contextLevel={contextLevel}
            path="/cenik"
            component={CenikPage}
          />
          {canReceiptAdmin &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/exportreceptur"
              component={ExportRecepturPage}
            />}

          {canImportPrices &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/importCen"
              component={ImportCenPage}
            />}

          {canReceiptAdmin &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/importreceptur"
              component={ImportRecepturPage}
            />}

          {canCopyReceipts &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/kopirovanireceptur"
              component={KopirovaniRecepturPage}
            />}
          {canCopyReceipts &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/kopirovanirecepturJobStatus"
              component={KopirovaniRecepturReportPage}
            />}

          <MainLayoutRoute
            contextLevel={contextLevel}
            path="/nastaveni"
            component={NastaveniPage}
          />
          {canColor && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/odstiny"
            component={OdstinyPage}
          />}
          {canPigment && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/pigmenty"
            component={PigmentyPage}
          />}
          <MainLayoutRoute
            contextLevel={contextLevel}
            path="/podpora"
            component={PodporaPage}
          />
          {canSeller && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/prodejci"
            component={ProdejciPage}
          />}
          {canReceipt && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/receptury"
            component={RecepturyPage}
          />}

          {canCustomReceipts && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/vlastnireceptury"
            component={RecepturyVlastniPage}
          />}

          {canDiscount && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/slevy"
            component={SlevyPage}
          />}
          {canToning && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/tonovani"
            component={TonovaniPage}
          />}
          {canUser && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/uzivatele"
            component={UzivatelePage}
          />}
          {canProduct && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/products"
            component={VyrobkyPage}
          />}
          {canSampleCard && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/vzorkovnice"
            component={VzorkovnicePage}
          />}
        </Switch>
      </Router>
    </div>
  );
};

export default App;
